<template>
    <div>
        <transition name="fade" mode="out-in">
            <div key="1" v-if="!complete">
                <h1>
                    Welcome! It's time to get ready to learn about the AAA Credit Card Program.
                </h1>
                <p>
                    You're only a few steps away from accessing the Visa Resource Center. Please watch the following two videos. Upon completion of both videos, you'll be asked to click the submit button so we can record your completion.
                </p>
            </div>
            <div key="2" v-else>
                <p>
                    You have finished the required education courses. These videos can be found on the Education page if you would like to rewatch the content at any time. Download your Fair and Responsible Banking compliance certificate below and retain for your records, then continue to the site.
                </p>
            </div>
        </transition>

        <slot></slot>

        <div v-if="!complete" class="mt-5 mb-3">
            <p class="mb-0">Videos should be viewed using the latest release of Google Chrome.</p>
        </div>
        <template v-if="complete && !pending">
            <p v-if="errorMessage && errorStatusCode !== 422" class="small mt-3 text-danger">{{ errorMessage }}</p>
            <div v-else class="d-flex align-items-center">
                <a href="/landing/annual-training/download">Download Certificate</a>
                <a href="/" class="btn-primary ml-3">Continue to the site</a>
            </div>
        </template>
    </div>
</template>

<script>
import eventBus from '@/event-bus';
import FormButton from '@/components/form/FormButton';
import FormInput from '@/components/form/FormInput';
import EmployeeTrainingVideoAnalyticService from '@/services/employee-training-video-analytic.service';
import TrainingService from '@/services/training.service';
import FormMixin from '@/mixins/FormMixin';

export default {
    components: {
        FormInput,
        FormButton
    },
    props: {
        requiredVideos: {
            type: Array,
            required: true
        },
        action: {
            type: String
        },
        csrf: {
            type: String
        }
    },
    mixins: [
        FormMixin
    ],
    data() {
        return {
            videos: this.requiredVideos,
            pending: false,
            complete: false
        }
    },
    mounted() {
        eventBus.$on('videoStarted', this.videoStarted);
        eventBus.$on('videoEnded', this.videoEnded);
    },
    methods: {
        async videoStarted(event) {
            try {
                await EmployeeTrainingVideoAnalyticService.store({
                    videoSlug: event.videoId,
                    completed: false,
                    started: true
                });
            } catch (error) {
                this.handleError(error);
            }
        },
        async videoEnded(event) {
            await EmployeeTrainingVideoAnalyticService.store({
                videoSlug: event.videoId,
                started: true,
                completed: true
            });

            this.videos = this.videos.filter(videoId => videoId !== event.videoId);

            if (!this.videos.length) {
                this.complete = true;

                this.pending = true;
                this.errorMessage = '';
                this.errorStatusCode = null;

                try {

                    await TrainingService.store();

                    this.success = true;
                } catch (error) {
                    this.handleError(error);
                } finally {
                    this.pending = false;
                }
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }
    .fade-enter, .fade-leave-to {
        opacity: 0;
    }
</style>
